var _defs, _path, _path2, _ellipse, _path3, _polygon, _rect, _rect2, _path4, _path5, _path6, _ellipse2, _polygon2, _polygon3, _rect3, _path7, _ellipse3, _path8, _circle, _rect4, _ellipse4, _path9, _path10, _polygon4, _polygon5, _line, _line2, _line3, _line4, _line5, _line6, _line7, _rect5, _line8, _path11, _path12, _path13, _path14, _path15, _line9, _line10, _line11, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _rect6, _line12, _path23, _path24, _line13, _line14, _line15, _line16, _line17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e2e2e2;}.cls-2{fill:#f3f3f3;}.cls-3{fill:#d37c59;}.cls-4{fill:#de8e68;}.cls-5{fill:#56cad8;}.cls-6{fill:#74d5de;}.cls-7{fill:#fed385;}.cls-8{fill:#dc8e6c;}.cls-9{fill:#fb836d;}.cls-10{fill:#d3d3d3;}.cls-11,.cls-13,.cls-14,.cls-15,.cls-16{fill:none;}.cls-11{stroke:#d3d3d3;stroke-miterlimit:10;}.cls-11,.cls-14,.cls-15{stroke-width:3.69px;}.cls-12{fill:#fed892;}.cls-13,.cls-14,.cls-16{stroke:#fed385;}.cls-13,.cls-14,.cls-15,.cls-16{stroke-linecap:round;stroke-linejoin:round;}.cls-13{stroke-width:3.84px;}.cls-15{stroke:#74d5de;}.cls-16{stroke-width:2.39px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M711.1,528.1c0-21.86-47-74.85-84.67-74.85-28.93,0-29.4,15.3-57.59,15.3-43.46,0-75.71-72.66-159.29-72.66-89.05,0-205.41,83.58-205.41,149.14C204.14,638.91,711.1,661.41,711.1,528.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M935.51,849.68c1-102,2.6-265.85,2.6-290.1,0-35.58-52.84-142.15-145.27-142.15-101.26,0-151.3,116.21-217.58,116.21-60.75,0-65.54-30.76-140.74-30.76-49,0-149.82,62.8-149.82,127l67.11,219.75Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 602.59,
    cy: 679.96,
    rx: 11.73,
    ry: 5.25,
    transform: "translate(-105.6 1249.11) rotate(-87.24)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M590.19,739.68c-.2-1.94,4.32-42.23,7.92-55a16,16,0,0,1,6.71-.94l-.34,39.7-5,18.67Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "620.7 683.58 589.26 686.18 588.26 679.96 618.52 670.39 620.7 683.58"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 544.3,
    y: 999.24,
    width: 13.77,
    height: 11.65
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 586.9,
    y: 1001.06,
    width: 13.77,
    height: 11.65
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M542.87,805V999.88H559l18.54-104.26S580.09,839.22,542.87,805Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M596,801.16c.45,5.62,6.06,107.88,6.06,107.88v93.11l-16.55,1.77-10.64-99-32-99.92C547.71,802.34,583.16,797.33,596,801.16Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M566.51,715.47c31.79,0,33.3,80.83,29.52,85.69s-49,8.17-53.16,3.83S526.9,715.47,566.51,715.47Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 607.86,
    cy: 679.96,
    rx: 11.73,
    ry: 5.25,
    transform: "translate(-100.59 1254.37) rotate(-87.24)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "585.61 1010.89 585.61 1022.54 618.35 1022.54 618.35 1018.3 601.32 1010.89 585.61 1010.89"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "543.87 1009.05 543.87 1020.7 576.61 1020.7 576.61 1016.46 559.58 1009.05 543.87 1009.05"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 585.55,
    y: 681.34,
    width: 3.86,
    height: 3.86,
    transform: "translate(-98.87 99.39) rotate(-8.92)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M568.84,722.5c0,2.67-12.41,3-12.41,0V696h12.41Z"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 568.46,
    cy: 688.32,
    rx: 13.03,
    ry: 19.89
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M545.77,680.12c0-6.13,2.67-10,4.84-11.23,4.19-2.4,5.94-1.33,10.16-3.2,4.57-2,8.49-7.84,13.84-7.84,5,0,4.55,2.84,7.94,3.68,2,.49,13.36-2.12,13.36,5.23,0,11.32-12.57,12.24-15.48,13.69a37.43,37.43,0,0,0-1.52-3.83c-2.29,2.36-10.58,4-11.92,4.53-3.1,1.28-4.58,6.13-4.58,9.3s-2.87,3.18-3.59,3.18C552.19,693.63,545.77,689.38,545.77,680.12Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 556.67,
    cy: 691.67,
    r: 4.33
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 512.81,
    y: 718.34,
    width: 25.14,
    height: 84.61,
    rx: 12.57,
    ry: 12.57
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 544.89,
    cy: 751.24,
    rx: 30.38,
    ry: 32.89
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M576.84,736.83c2.53,0,15.29.53,20.48,2.4.4-2.53,2.66-38.77,6.51-50.91,1.47-1.62,7.45-1.43,7.45,0s8.51,60.88,0,67.93-37.37-2.4-38.56-3.33S576.84,736.83,576.84,736.83Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M549.66,734.69c2.82-11.48,28.36-1.93,30.67.69,2.77,3.14-2.18,20.84-6,21.66C568.1,758.39,546,749.58,549.66,734.69Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "266.38 341.65 142.64 849.68 390.13 849.68 266.38 341.65"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "169.62 341.65 45.87 893.9 293.36 893.9 169.62 341.65"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 170.29,
    y1: 891.44,
    x2: 170.29,
    y2: 395.36
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 170.29,
    y1: 558.95,
    x2: 197.18,
    y2: 529.72
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 170.29,
    y1: 698.94,
    x2: 210.7,
    y2: 655.02
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 170.29,
    y1: 844.98,
    x2: 233.14,
    y2: 776.66
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 170.29,
    y1: 558.95,
    x2: 143.4,
    y2: 529.72
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 170.29,
    y1: 698.94,
    x2: 129.89,
    y2: 655.02
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 170.29,
    y1: 844.98,
    x2: 107.44,
    y2: 776.66
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 190.5,
    y: 734.34,
    width: 135.39,
    height: 197.16,
    rx: 67.69,
    ry: 67.69
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 258.19,
    y1: 982.94,
    x2: 258.19,
    y2: 795.85
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M258.19,875.41c37,0,37-22.28,37-56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M258.19,841.33c-25.65,0-25.65-15.47-25.65-38.84"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1152.37,849.68V667.57a81.52,81.52,0,0,0-81.28-81.28h0a81.65,81.65,0,0,0-13.07,1.06V377.78a55.64,55.64,0,0,0-55.63-55.64h0a55.64,55.64,0,0,0-55.64,55.64v44.86a80.64,80.64,0,0,0-26-4.31h0a81.52,81.52,0,0,0-81.28,81.29V649H804.08a55.7,55.7,0,0,0-55.53,55.53V833.86a55.18,55.18,0,0,0,2.32,15.82Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1000.16,740.85c91.61,0,91.61-41,91.61-103"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1000.25,795.48c-50.4,0-50.4-22.56-50.4-56.67"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 1000.16,
    y1: 849.68,
    x2: 1000.16,
    y2: 364.17
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 1000.16,
    y1: 637.85,
    x2: 949.94,
    y2: 587.62
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-15",
    x1: 1000.16,
    y1: 534.21,
    x2: 1030.55,
    y2: 503.83
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M750.49,341.65a47.18,47.18,0,0,0-86.25-35.55,37.43,37.43,0,0,0-52.84,34.1c0,.49,0,1,0,1.45Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M291.91,268.28a47.18,47.18,0,0,1,86.25-35.55A37.4,37.4,0,0,1,431,266.83c0,.48,0,1,0,1.45Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M924.33,936.06c-50.28,0-91,21.47-91,48h182.05C1015.35,957.53,974.6,936.06,924.33,936.06Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M502.76,1006.93c-12.55,0-22.73,8.76-22.73,19.57H525.5C525.5,1015.69,515.32,1006.93,502.76,1006.93Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M833.3,902.44c-12.56,0-22.73,13-22.73,29.06H856C856,915.45,845.85,902.44,833.3,902.44Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M120.87,974.57c-20,0-36.16,6.51-36.16,14.53H157C157,981.08,140.84,974.57,120.87,974.57Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1030.55,974.57c-20,0-36.16,6.51-36.16,14.53h72.31C1066.7,981.08,1050.52,974.57,1030.55,974.57Z"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 838.22,
    y: 746.55,
    width: 87.67,
    height: 127.66,
    rx: 43.83,
    ry: 43.83
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 882.06,
    y1: 907.53,
    x2: 882.06,
    y2: 786.38
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M882.06,837.9C906,837.9,906,823.47,906,801.64"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M882.06,815.83c-16.61,0-16.61-10-16.61-25.16"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 331.71,
    y1: 947.65,
    x2: 412.75,
    y2: 947.65
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 668.4,
    y1: 893.9,
    x2: 722.14,
    y2: 893.9
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 627.87,
    y1: 907.53,
    x2: 681.62,
    y2: 907.53
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 116.88,
    y1: 918.64,
    x2: 170.63,
    y2: 918.64
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 748.55,
    y1: 999.24,
    x2: 824.1,
    y2: 999.24
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisc);
export default __webpack_public_path__ + "static/media/disc.9f31958f5f28fd001f5dc3afa67cc53b.svg";
export { ForwardRef as ReactComponent };